import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Col, Icon, Button } from 'antd';
import Zmage from 'react-zmage';
import LazyLoad from 'react-lazy-load';
import util from '../../util';

const {
  getAccessToken
} = util;

const store = ['ecodeWfStore', 'homeStore'];
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'ecode-wf-single'
  }
  getParams = () => {
    const { ecodeWfStore: { searchFormValue } } = this.props;
    let _searchFormValue = {...toJS(searchFormValue)};
    Object.keys(_searchFormValue).map(
      key => {
        _searchFormValue[key] || delete _searchFormValue[key]
      }
    )
    return _searchFormValue;
  }

  download = (e, id, folderId) => {
    const url = `${window.server}/v5/ecode/download?id=${id}&access_token=${getAccessToken()}`;
    const { ecodeWfStore: { download }, onChange  } = this.props;
    download(folderId).then((data) => {
      window.open(url);
      typeof onChange === 'function' && onChange();
    })
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  apply = (id, name) => {
    const { ecodeWfStore: { setApply, setState } } = this.props;
    setApply({appId: id, title: name});
    setState({applyVisible: true});
  }
  getLabel = (data) => {
    const { functionList = [], genreList = []} = data;
    let res = '';
    functionList.forEach((da) => res += `${da.g_name || da.name} ` )
    genreList.forEach((da) => res += `${da.g_name || da.name} ` )
    return res;
  }
  details = (id, demoId) => {
    const { ecodeWfStore: { routing }, details } = this.props;
    if(typeof details === 'function') {
      details(id, demoId);
      return;
    }
    routing.push({
      pathname: `/app/workflowDetail/${id}`,
      query: {
        demoId,
      }
    });
  }
  addCollect = id => {
    const { homeStore: { addCollect, addCollectLoading }, onChange } = this.props;
    if(!addCollectLoading) { 
      addCollect({appId: id}).then(data => 
        data.status && typeof onChange === 'function' && onChange()
      );
    }
  }
  workDownload = (id, appid) => {
    const { onDownload } = this.props;
    typeof onDownload === 'function' && onDownload(id, appid);
  }
  setStars = id => {
    const { onStars } = this.props;
    typeof onStars === 'function' && onStars(id);
  }
  render() {
    const { prefixCls, data, num = 4, needApply } = this.props;
    const defaultImg = '/cloudstore/resource/pc/com/images/ecode-wf-empty.png';
    const img = data.imageList && data.imageList.length > 0 ? data.imageList[0] : {};
    return (
      <Col span={24 / num} className={`${prefixCls}-table-col`}>
        <div className={`${prefixCls}-table-single ${needApply && `${prefixCls}-table-single-needApply`}`}>
          <div className={`${prefixCls}-table-single-num`}>
            <span className={`${prefixCls}-table-single-num-first`}>
              <Icon type="eye" className={`${prefixCls}-table-single-num-icon`} />
              {data.visits || 0}
            </span>
            <span className={`${prefixCls}-table-single-num-first pointer`} onClick={() => this.workDownload(data.id, data.folderId)}>
              <Icon type="download" className={`${prefixCls}-table-single-num-icon`} />
              {data.downloadCounts || 0}
            </span>
            <span className="pointer" onClick={() => this.setStars(data.folderId)}>
              <Icon type="like" theme={data.thumbsupStatus === 'y' ? "filled" : "" } className={`${prefixCls}-table-single-num-icon ${data.thumbsupStatus === 'y' ? "heart-active" : ""}`} />
              {data.thumbsup || 0}
            </span>
          </div>
          <div className={`${prefixCls}-table-single-image`} onClick={() => this.details(data.folderId, data.id)}>
            {
              needApply ? (<div className={`${prefixCls}-table-single-image-hover home-page-theme-list-item-card`}>
                <LazyLoad>
                  <img src={img.imageLink || img.thumbnailLink || defaultImg} />
                </LazyLoad>
                <div className={`${prefixCls}-table-single-image-hover-mask theme-card-mask`}/>
                <div className="theme-card-title">
                  <Button type="primary" disabled={!data.attr || !data.attr.previewUrl || data.attr.previewUrl === ''}onClick={() => {
                      window.open(data.attr.previewUrl);
                      // 打开页面之后新增阅读量，新页面需要走接口，带解决，考虑页面通信或者缓存
                  }}>预览({data.visits || 0})</Button>
                  <Button onClick={(e) => {
                    this.download(e, data.id, data.folderId);
                    // this.apply(data.folderId, data.title);
                  }}>下载({data.downloadCounts || 0})</Button>
                </div>
                <div className="theme-card-title-collect">
                  <Icon type="star" />
                  收藏
                </div>
              </div>) : (
                // <Zmage src={img.imageLink || img.thumbnailLink || defaultImg} style={{ maxWidth: "100%", maxHeight: "100%" }} />
                <img src={img.imageLink || img.thumbnailLink || defaultImg}/>
              )
            }
          </div>
          <div className={`${prefixCls}-table-single-desc`}>
            <div className={`${prefixCls}-table-single-desc-single`}>
            <div className={`${prefixCls}-table-single-desc-single-tags`}>表单标签：<span title={this.getLabel(data)}>{this.getLabel(data)}</span></div>
            </div>
            <div className={`${prefixCls}-table-single-desc-single`}>
              <div>分享人：<span>{data.creatorName}</span></div>
              <div>分享来源：{ data.isWeaver !== false ? '泛微内部' : '客户' }</div>
            </div>
          </div>
          <div className={`${prefixCls}-table-single-desc`}>
            <div className={`${prefixCls}-table-single-desc-single`}>
              {/* <div>{data.createDate} {data.createTime}</div> */}
              <div>{data.modifyDate}</div>
              <div className={`${prefixCls}-table-single-desc-single-right`}>
                {
                  needApply ? (
                    <div className={`${prefixCls}-table-single-num`}>
                      <div className={`${prefixCls}-table-single-num-first`}>
                        <Icon type="eye" className={`${prefixCls}-table-single-num-icon`} />
                        {data.visits || 0}
                      </div>
                      <div className={`${prefixCls}-table-single-num-first`} >
                        <Icon type="download" className={`${prefixCls}-table-single-num-icon`} />
                        {data.downloadCounts || 0}
                      </div>
                      <div>
                        <Icon type="like" className={`${prefixCls}-table-single-num-icon`} />
                        {data.thumbsup || 0}
                      </div>
                    </div>
                  ) : [
                    <span
                      className={`${prefixCls}-table-single-desc-detail`}
                      key="collect"
                      onClick={() => {
                        this.addCollect(data.folderId)
                      }}
                    >
                      {data.starStatus === 'y' ? '取消收藏' : '收藏'}
                    </span>,
                    <span key="detail" className={`${prefixCls}-table-single-desc-detail`} onClick={() => this.details(data.folderId, data.id)}>
                      详情
                    </span>,
                  ]
                }
              </div>
            </div>
          </div>
      </div>
      <div className={`${prefixCls}-table-col-title app-text-elli`} title={data.title}>
        {data.title}
      </div>
    </Col>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/main/SingleEcodeWf.js